import { gql } from "@apollo/client";

const PURCHASER_CONFIG_TEMPLATE_FIELDS = `
  configTemplateId
  appPurchaserId
  metadata
  searchKeywords
  intelligenceFilter
  deductionTypeInvoicePatternForDiscount
  additionalFieldMapping
  discountTermAgreementDaysTolerance
  isActive
`;

export const GET_PURCHASER_CONFIG_TEMPLATE = gql`
  query PurchaserConfigTemplate($purchaserId: Int!) {
    purchaserConfigTemplate(purchaserId: $purchaserId) {
      ${PURCHASER_CONFIG_TEMPLATE_FIELDS}
    }
  }
`;

export const UPDATE_PURCHASER_CONFIG_TEMPLATE = gql`
  mutation UpdatePurchaserConfigTemplate(
    $params: UpdatePurchaserConfigTemplateInput!
  ) {
    updatePurchaserConfigTemplate(params: $params) {
      ${PURCHASER_CONFIG_TEMPLATE_FIELDS}
    }
  }
`;
